import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { SaveConfigPromotionRequest } from 'src/app/model/promotion-models';
import { CommissionPromotionsService } from 'src/app/services/commission-promotions.service';
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-new-promotion",
  templateUrl: "./modal-new-promotion.component.html",
  styleUrls: ["./modal-new-promotion.component.css"],
})
export class ModalNewPromotionComponent implements OnInit {
  @Input() mode: string;
  @Input() selectedFieldIds: number[] = []; // ← campos pre-seleccionados al editar
  @Input() nombrePadre: string; 
  @Output() fieldsSelected = new EventEmitter<any[]>(); // ← devuelve los campos al padre
  @Output() closed = new EventEmitter<string>();

  now = new Date();
  promotionFields: CatalogModel[] = [];
  promotionFieldsActive: number[] = [];
  promotionName: string;
  public viewStatus = 1;

  public customPatterns = {
    A: { pattern: new RegExp("[a-zA-Z0-9ñÑ ]") }, // inputs regulares
    C: { pattern: new RegExp("[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%/() -]") }, // comentarios (acepta acentos, comas y puntos)
    N: { pattern: new RegExp("[0-9]") },
  };

  private promotionSchema: SaveConfigPromotionRequest = {
    catPromotionSchema: {},
    promotionFieldsActive: {},
  } as SaveConfigPromotionRequest;


  constructor(
    private commissionPromotionsService: CommissionPromotionsService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [{ responsivePriority: 1, width: 100, targets: -1 }],
    bLengthChange: false,
    searching: false,
    dom: '<"row"<"col"l><"col"<"text-center">><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    //buttons: ['csv', 'excel'],
    autoWidth: false,
    // pagingType: 'full_numbers',
    paging: false,
    pageLength: 5,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
      // dom: 'Bfrtip',
      buttons: ["excel"],
    },
  };

  ngOnInit() {
    console.log("Modo del modal:", this.mode);
    console.log("Nombre del padre:", this.nombrePadre);
    this.getCatalogs();
  }

  onCheck(fieldId: number) {
    const idx = this.promotionFieldsActive.indexOf(fieldId);
    if (idx === -1) {
      this.promotionFieldsActive.push(fieldId);
      if (fieldId == 20) {
        Swal.fire(
          "CUIDADO",
          "Las configuraciones que incluyen el campo de Clave Promoción tienen prioridad sobre las demás. Úselo con precaución.",
          "warning"
        );
      }
    } else {
      this.promotionFieldsActive.splice(idx, 1);
    }
  }

  isChecked(fieldId: number): boolean {
    return this.promotionFieldsActive.indexOf(fieldId) !== -1;
  }

  confirm() {
    if (this.promotionFieldsActive.length === 0) {
      this.toastr.warning('Selecciona al menos un campo');
      return;
    }

    // Construir lista de campos seleccionados con la estructura que espera el backend
    const userId = parseInt(localStorage.getItem('UserId'), 10) || 0;
    const camposSeleccionados = this.promotionFields
      .filter(f => this.promotionFieldsActive.indexOf(f.id) !== -1)
      .map(f => ({
        campoId: f.id,
        nombreCampo: f.description,
        activoId: 1,
        usuarioId: userId,
        fechaCreacion: null,
      }));

    // Emitir al componente padre
    this.fieldsSelected.emit(camposSeleccionados);
    this.closed.emit('confirm');
  }

  close(reason: string) {
    this.closed.emit(reason);
  }

  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError())
      errors.push("Necesita capturar un nombre para la nueva promoción.");
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join("<br>"), "¡Atención!", {
        enableHtml: true,
      });
    }
    return valid;
  };

  // Aqui falta cambiar la captura de información y cambiar el consumo de servicio para crear una nueva promoción, falta crear el servicio
  save = () => {
    console.log(this.promotionName);

    if (this.isValid()) {
      this.viewStatus = 0;

      this.promotionSchema.catPromotionSchema.promotionSchemaName =
        this.promotionName.toUpperCase();
      this.promotionSchema.catPromotionSchema.userId = Number(
        localStorage.getItem("UserId")
      );
      this.promotionSchema.promotionFieldsActive = this.promotionFieldsActive;

      this.commissionPromotionsService
        .savePromotionSchemaConfiguration(this.promotionSchema)
        .subscribe(
          (response) => {
            console.log(response);
            if (response.httpStatusCode >= 200 && response.httpStatusCode < 300) {
              this.modalService.dismissAll("success");
              this.toastr.success("La configuración se guardo con exito");
            } else {
              this.viewStatus = 1;
              this.toastr.warning("Ocurrió un error al intentar guardar la configuración.");
              this.toastr.warning("Asegurate de seleccionar al menos un campo de configuración e intentalo nuvemente.");
              console.log(response.messageError);
            }
          },
          (error) => {
            console.log(error);
            this.modalService.dismissAll("failure");
            this.toastr.error("Ocurrió un error inesperado, intentalo nuevamente más tarde.");
          }
        );
    }
  };

  // HELPERS
  descriptionError = () => !this.promotionName || this.promotionName.trim() === "";

  getCatalogs = () => { 
    this.commissionPromotionsService.getCatalogPromotionFields().subscribe(
      (response: any) => {
        this.promotionFields = response;
        // Pre-seleccionar campos si vienen del padre (modo edición)
        if (this.selectedFieldIds && this.selectedFieldIds.length > 0) {
          this.promotionFieldsActive = [...this.selectedFieldIds];
        }
        if (this.nombrePadre === "meta") {
          this.promotionFields = this.promotionFields.filter(f => f.id !== 20); // Filtrar el campo de plazos
          this.promotionFields = this.promotionFields.filter(f => f.id !== 22); // Filtrar el campo de plazos
        }
        this.viewStatus = 1;
      },
      (error) => {
        this.viewStatus = -1;
        this.toastr.error("Error al obtener los campos disponibles");
        console.error(error);
        this.close("error");
      }
    );
  }
}
